export type PortfolioReserveYearsType = {
    prTargetInputYears?: number,
    minimumRiskInputYears?: number
};

export const emptyPortfolioReserveYears: PortfolioReserveYearsType = {
    prTargetInputYears: undefined,
    minimumRiskInputYears: undefined
}